// extracted by mini-css-extract-plugin
export default {"container":"ManageOrders_container__5CQh-","heading":"ManageOrders_heading__ZtWLz","manageSection":"ManageOrders_manageSection__srMMI"};